import { BENCHMARK_STRENGTH } from '../../helpers/dataHelpers/getBenchmarkStrength'

/**
 * @param {object} props
 * @param {number} props.currentScore - Final strength score (0-3), highlights the matching table row
 * @param {number} props.companyCount - Number of organisations in the benchmark
 * @param {number} props.respondentCount - Respondent count shown next to the label
 * @param {number} props.largestShare - Largest single organisation's share of the data, in %
 * @param {string} [props.respondentLabel] - What the respondent count represents; passed through from BenchmarkHeader (MSI: 'Ingevulde vragenlijsten', participatieladder: 'Medewerkers')
 */
const StrengthExplanation = ({ currentScore, companyCount, respondentCount, largestShare, respondentLabel = 'Ingevulde vragenlijsten' }) => (
    <div className='bd-strength-explanation'>
        <p className='bd-strength-explanation-intro'>
            De sterkte wordt bepaald door drie factoren: aantal organisaties, aantal {respondentLabel.toLowerCase()} en spreiding van de data. De laagste score van de drie bepaalt de totaalscore.
        </p>
        <div className='bd-strength-current-values'>
            <div className='bd-strength-current-value'>
                <span className='bd-strength-current-value-label'>Organisaties</span>
                <span className='bd-strength-current-value-number'>{companyCount}</span>
            </div>
            <div className='bd-strength-current-value'>
                <span className='bd-strength-current-value-label'>{respondentLabel}</span>
                <span className='bd-strength-current-value-number'>{respondentCount}</span>
            </div>
            <div className='bd-strength-current-value'>
                <span className='bd-strength-current-value-label'>Spreiding</span>
                <span className='bd-strength-current-value-number'>{largestShare}%</span>
            </div>
        </div>
        <table className='bd-strength-explanation-table'>
            <thead>
                <tr>
                    <th>Niveau</th>
                    <th>Organisaties</th>
                    <th>{respondentLabel}</th>
                    <th>Spreiding</th>
                </tr>
            </thead>
            <tbody>
                {Object.entries(BENCHMARK_STRENGTH).map(([scoreKey, level]) => {
                    const score = Number(scoreKey)
                    return (
                        <tr
                            key={score}
                            className={score === currentScore ? 'bd-strength-row--current' : ''}
                        >
                            <td><strong>{level.label}</strong> ({score + 1}/4)</td>
                            <td>{level.orgs}</td>
                            <td>{level.respondents}</td>
                            <td>{level.spread}</td>
                        </tr>
                    )
                })}
            </tbody>
        </table>
    </div>
)

export default StrengthExplanation
